import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import {Modal} from "ngx-modal";
import { HTTPService } from '../../shared/services/http.service';
import { LoginComponent } from '../login/login.component';
import { LogoutComponent } from '../logout/logout.component';
import { ISubscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-login-dialog',
  templateUrl: './login-dialog.component.html',
  styleUrls: ['./login-dialog.component.css']
})
export class LoginDialogComponent implements OnInit,OnDestroy {

  @ViewChild('modal') modal: Modal;
  private _isOpen:boolean;

  private _userSubscription:ISubscription;
  private _httpSubscription:ISubscription;

  constructor(
    private authService:AuthService
    ,private httpService:HTTPService
    ,private route:ActivatedRoute
    ,private router:Router
  ) { 
    this._isOpen = false;
  }

  public handleClose() {
    this._isOpen = false;
  }
  public goToAdminLogin() {
    this.authService.logout().then(() => {
      this.router.navigate(['/loginAdmin']).then(() => {
        this.closeDialog();
      });
    });
  }
  public goToClientLogin() {
    
    this.authService.logout().then(() => {
      this.router.navigate(['/login']).then(() => {
        this.closeDialog();
      });
    });
  }
  private openDialog() {
    let childUrl = this.route.snapshot.firstChild ? this.route.snapshot.firstChild.url.join("").trim() : "";
    if (childUrl == ""
        || childUrl.endsWith("home")
        || childUrl.endsWith("login")
        || childUrl.endsWith("loginAdmin")
        || childUrl.endsWith("logout")) {
      return;
    }

    if (!this._isOpen) {
        this.modal.open();
    }
    this._isOpen = true;
  }
  private closeDialog() {
    if (this._isOpen) {
      this.modal.close();
    }
    this._isOpen = false;
  }
  ngOnInit() {
    this._httpSubscription = this.httpService.currentStatus().subscribe((statusCode) => {
      if (statusCode === 401) {
        this.openDialog();
      }
    });
    this._userSubscription = this.authService.getLoginState().subscribe((loginState) => {
      if (loginState.isLoggedIn) {
        this.closeDialog();
      }
      else {
        this.openDialog();
      }
    });
  }

  ngOnDestroy() {
    this._userSubscription.unsubscribe();
    this._httpSubscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login-dialog/login-dialog.component.ts